import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import { actions as globalActions } from '@elab/core/store/global';
import { actions as socialActions } from '@elab/core/store/social';
import { actions as uiActions, selectors as uiSelectors } from '@elab/core/store/ui';
import { backSocialActions } from '@elab/core/utils/constants';
import connect from '@elab/core/store/connect';

export class SocialForm extends LightLitElement {
    static get properties() {
        return {
            name: { type: String },
            fieldValue: { type: String },
            selectedRadio: { type: String, attribute: false },
            loginURL: { type: String, attribute: 'login-url' },
            registrationURL: { type: String, attribute: 'registration-url' },
            submitButtonLabel: {
                type: String,
                attribute: 'submit-button-label',
            },
            checkout: { type: Boolean },
            appId: { type: String, attribute: 'app-id' },
            isWtr: { type: Boolean, attribute: 'is-wtr' },
            socialButtonProceedText: { type: String, attribute: 'social-button-proceed-text' },
            isDialogOpen: { type: Boolean, attribute: false },
            providerType: { type: String, attribute: 'provider-type' },
        };
    }

    constructor() {
        super();

        this.name = '';
        this.loginURL = '/login';
        this.registrationURL = '/registration';
        this.checkout = false;
        this.appId = '';
        this.isWtr = false;
        this.socialButtonProceedText = '';
        this.selectedRadio = '';
        this.isDialogOpen = false;
        this.providerType = '';
        this.isRadioChange = false;
    }

    firstUpdated() {
        if (this.fieldValue.length === 3) {
            this.selectedRadio = 'REGISTER';
        } else {
            this.selectedRadio = '';
        }
    }

    onRadioChange({ detail }) {
        this.selectedRadio = detail;
        this.isRadioChange = true;
    }

    onSubmit(e) {
        e.preventDefault();
        const { selectedRadio, checkout } = this;

        const selectedAction = this.fieldValue.find(({ action }) => action === selectedRadio);

        if (selectedRadio == 'REGISTER' && this.isWtr) {
            let token = '';
            if (this.providerType === 'facebook') {
                const fbToken = JSON.parse(sessionStorage.getItem(`fbssls_${this.appId}`));
                token = fbToken.authResponse.accessToken;
            } else if (this.providerType === 'google') {
                token = sessionStorage.getItem('googleAuthToken');
            }
            selectedAction.data.socialProfile = {
                ...selectedAction.data.socialProfile,
                accessToken: token,
            };
        }

        if (selectedRadio && selectedAction) {
            this.dispatchEvent(
                new CustomEvent('set-social-info', { detail: { ...selectedAction, checkout } }),
            );

            this.dispatchEvent(new CustomEvent('close-dialog'));

            if (checkout) {
                return;
            }

            const redirectBySelectedRadio = {
                [backSocialActions.register]: this.registrationURL,
                [backSocialActions.login]: this.loginURL,
                [backSocialActions.connect]: this.loginURL,
            };
            const url = redirectBySelectedRadio[selectedRadio];
            if (url) {
                this.dispatchEvent(new CustomEvent('redirect', { detail: url }));
            }
        }
    }

    render() {
        if (!this.isRadioChange && this.isDialogOpen) {
            if (this.fieldValue.length == 3) {
                this.selectedRadio = 'REGISTER';
            } else {
                this.selectedRadio = '';
            }
        }
        this.isRadioChange = false;
        if (this.fieldValue) {
            return html`
                <form>
                    <e2-radio-group
                        name="${this.fieldValue.map(item => item.action)}"
                        @change_radio="${this.onRadioChange}"
                        .values="${this.fieldValue.map(item => ({
                            label: item.title,
                            name: item.action,
                        }))}"
                        .value="${this.selectedRadio}"
                    >
                    </e2-radio-group>
                    <e2-button
                        @click=${this.onSubmit}
                        class-modifier="button--primary social-button--proceed"
                        size="medium"
                        type="submit"
                    >
                        <span>${this.socialButtonProceedText}</span>
                    </e2-button>
                </form>
            `;
        }
    }
}

const mapStateToProps = (state, ctx) => ({
    fieldValue: ctx.name
        .split('.')
        .reduce((acc, storeFieldName) => (!acc ? undefined : acc[storeFieldName]), state),

    isDialogOpen:
        uiSelectors.getDialogName(state) === 'facebook-dialog' ||
        uiSelectors.getDialogName(state) === 'google-dialog',
});

const mapDispatchToEvents = dispatch => ({
    redirect: ({ detail }) => dispatch(globalActions.redirect(detail)),
    'close-dialog': () => dispatch(uiActions.closeDialog()),
    'set-social-info': ({ detail }) => dispatch(socialActions.setSocialInfo(detail)),
});

export default () =>
    customElements.define(
        'e2-social-form',
        connect(mapStateToProps, mapDispatchToEvents)(SocialForm),
    );
